import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { TTicketComment } from '../../types/ticket-comment.type';

export interface ITicketCommentStore {
  /**
   * State
   */
  countTicketComment: number;
  isLoadingFetchCountTicketComment: boolean;
  editedTicketComment: TTicketComment | null;

  /**
   * Actions
   */
  actions: {
    setEditedTicketComment: (ticketComment: TTicketComment | null) => void;
    setCountTicketComment: (countTicketComment: number) => void;
    setIsLoadingFetchCountTicketComment: (isLoadingFetchCountTicketComment: boolean) => void;
  };
}

export const ticketCommentStore = create<ITicketCommentStore>((set) => ({
  /**
   * State
   */

  countTicketComment: 0,
  isLoadingFetchCountTicketComment: false,
  editedTicketComment: null,

  /**
   * Actions
   */
  actions: {
    setEditedTicketComment: (ticketComment: TTicketComment | null) => set({ editedTicketComment: ticketComment }),
    setCountTicketComment: (countTicketComment: number) => {
      set({ countTicketComment });
    },
    setIsLoadingFetchCountTicketComment: (isLoadingFetchCountTicketComment: boolean) => {
      set({ isLoadingFetchCountTicketComment });
    },
  },
}));

/**
 * Actions
 */
export const useTicketCommentActionsStore = () => ticketCommentStore(useShallow((state) => state.actions));

/**
 * Selectors
 */
export const useCountTicketCommentStore = () => ticketCommentStore(useShallow((state) => state.countTicketComment));
export const useIsLoadingFetchCountTicketCommentStore = () =>
  ticketCommentStore(useShallow((state) => state.isLoadingFetchCountTicketComment));
export const useEditedTicketCommentStore = () => ticketCommentStore(useShallow((state) => state.editedTicketComment));
